'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isNextYear.js
// module id = 551
// module chunks = 0